/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfrastructureResourcesByResourceCategoryWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("InfrastructureResourcesByResourceCategoryWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return InfrastructureResourcesByResourceCategoryWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<InfrastructureResourcesByResourceCategoryWidgetConfiguration>): InfrastructureResourcesByResourceCategoryWidgetConfiguration {
        let obj = Object.assign(new InfrastructureResourcesByResourceCategoryWidgetConfiguration(), model);
        InfrastructureResourcesByResourceCategoryWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfrastructureResourcesByResourceCategoryWidgetConfiguration>): InfrastructureResourcesByResourceCategoryWidgetConfiguration {
        if (!model) return null;
        return InfrastructureResourcesByResourceCategoryWidgetConfiguration.newInstance(<InfrastructureResourcesByResourceCategoryWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfrastructureResourcesByResourceCategoryWidgetConfiguration) {
        if (!obj) return;

        models.InfrastructureResourcesByResourceCategoryWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfrastructureResourcesByResourceCategoryWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, InfrastructureResourcesByResourceCategoryWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
